export default "__VITE_ASSET__416fc82b__"